import {EntityManagePage} from "base/entity";
import {useConfigModule} from "base/provider";

const ManageColectorPage = () => {
    const {moduleFilter} = useConfigModule();

    return <EntityManagePage filter={moduleFilter}></EntityManagePage>;
};
export default ManageColectorPage;
